import React from 'react';
import { Button, Badge } from 'react-bootstrap';
import { FaBell, FaExternalLinkAlt, FaTrash } from 'react-icons/fa';
import CommonModal from '../common/CommonModal';
import { formatDate, formatDateTime, formatTime } from '../../utils/formatUtils';

const SystemNotificationDetailModal = ({
  show,
  onHide,
  notification,
  loading = false,
  onOpenRecord,
  onDelete,
  deleting = false,
}) => {
  if (!notification && !loading) {
    return null;
  }

  const notificationId = notification?.id ?? notification?.notification_id;
  const isUnread =
    notification &&
    (notification.is_read === false ||
      notification.is_read === 'false' ||
      notification.is_read == null);
  const hasRecord =
    notification?.related_object &&
    notification?.parentid &&
    String(notification.related_object).trim() !== '' &&
    String(notification.parentid).trim() !== '';

  const relatedLabel = hasRecord
    ? String(notification.related_object).charAt(0).toUpperCase() +
      String(notification.related_object).slice(1)
    : null;

  const footer = (
    <div className='d-flex flex-wrap gap-2 justify-content-between w-100'>
      <div className='d-flex flex-wrap gap-2'>
        {hasRecord && onOpenRecord && (
          <Button
            variant='primary'
            size='sm'
            onClick={() => onOpenRecord(notification)}
          >
            <FaExternalLinkAlt className='me-1' />
            Open {relatedLabel}
          </Button>
        )}
        {notificationId && onDelete && (
          <Button
            variant='outline-danger'
            size='sm'
            disabled={deleting}
            onClick={() => onDelete(notificationId)}
          >
            <FaTrash className='me-1' />
            {deleting ? 'Deleting…' : 'Delete'}
          </Button>
        )}
      </div>
      <Button variant='secondary' size='sm' onClick={onHide}>
        Close
      </Button>
    </div>
  );

  return (
    <CommonModal
      show={show}
      onHide={onHide}
      title={notification?.title || 'Notification'}
      subtitle={
        notification?.createddate
          ? formatDateTime(notification.createddate)
          : ''
      }
      size='md'
      centered
      headerIcon={<FaBell style={{ color: '#0176d3' }} />}
      customFooter={footer}
      showCloseButton={false}
    >
      {loading ? (
        <div className='text-center text-muted py-4'>Loading…</div>
      ) : (
        <div className='system-notification-detail'>
          <div className='d-flex align-items-center gap-2 mb-3'>
            {isUnread ? (
              <Badge bg='primary'>Unread</Badge>
            ) : (
              <Badge bg='secondary'>Read</Badge>
            )}
            {notification.notification_type && (
              <Badge bg='light' text='dark' className='border'>
                {String(notification.notification_type).replace(/_/g, ' ')}
              </Badge>
            )}
          </div>

          {notification.message && (
            <div className='mb-3'>
              <div className='text-muted small mb-1'>Message</div>
              <div style={{ whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>
                {notification.message}
              </div>
            </div>
          )}

          {notification.task_description && (
            <div className='mb-3'>
              <div className='text-muted small mb-1'>Task description</div>
              <div style={{ whiteSpace: 'pre-wrap' }}>
                {notification.task_description}
              </div>
            </div>
          )}

          {notification.task_type && (
            <div className='mb-2'>
              <span className='text-muted small'>Type: </span>
              {notification.task_type}
            </div>
          )}

          {notification.task_due_date && (
            <div className='mb-2'>
              <span className='text-muted small'>Due: </span>
              {formatDate(notification.task_due_date)}
            </div>
          )}

          {(notification.task_meeting_start_datetime ||
            notification.task_meeting_end_datetime) && (
            <div className='mb-2'>
              {notification.task_meeting_start_datetime && (
                <div>
                  <span className='text-muted small'>Meeting start: </span>
                  {formatDateTime(notification.task_meeting_start_datetime)}
                </div>
              )}
              {notification.task_meeting_end_datetime && (
                <div>
                  <span className='text-muted small'>Meeting end: </span>
                  {formatDateTime(notification.task_meeting_end_datetime)}
                </div>
              )}
            </div>
          )}

          <div className='text-muted small mt-3 pt-2 border-top'>
            {notification.createdbyname && (
              <div>
                <span className='me-1'>From:</span>
                {notification.createdbyname}
              </div>
            )}
            {notification.createddate && (
              <div>
                <span className='me-1'>Received:</span>
                {formatTime(notification.createddate)}
              </div>
            )}
            {hasRecord && (
              <div>
                <span className='me-1'>Related:</span>
                {relatedLabel} ({notification.parentid})
              </div>
            )}
          </div>
        </div>
      )}
    </CommonModal>
  );
};

export default SystemNotificationDetailModal;
